import dayjs from 'dayjs';
import 'dayjs/locale/de';

dayjs.locale('de');

/**
 * Formats termin date/time display
 * @returns "Montag, 5. Februar · 14:00 – 16:00" or "Montag, 5. Februar"
 */
export function formatTerminDateTime(
  datum: string,
  beginn?: string | null,
  ende?: string | null,
): string {
  const dateDayjs = dayjs(datum);
  const datePart = dateDayjs.format('dddd, D. MMMM YYYY');

  if (!beginn) {
    return datePart;
  }

  const startTime = dayjs(beginn).format('HH:mm');
  const endTime = ende ? ` – ${dayjs(ende).format('HH:mm')}` : '';

  return `${datePart} · ${startTime}${endTime}`;
}

/**
 * Formats arbeitszeit time range
 * @returns "14:00 – 16:00"
 */
export function formatArbeitszeitTimeRange(
  beginn?: string | null,
  ende?: string | null,
): string {
  if (beginn && ende) {
    const startTime = dayjs(beginn).format('HH:mm');
    const endTime = dayjs(ende).format('HH:mm');
    return `${startTime} – ${endTime}`;
  }
  if (beginn) {
    const startTime = dayjs(beginn).format('HH:mm');
    return `${startTime} – ?`;
  }
  if (ende) {
    const endTime = dayjs(ende).format('HH:mm');
    return `? – ${endTime}`;
  }
  return '';
}
